<template>
  <div id="standard_defect_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="standardDefectHeader" v-if="$route.params.id > 0">Update Standard Defect</span>
                <span class="page-title" id="standardDefectHeader" v-else>Add Standard Defect</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackStandardDefectList" >
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content standard-defect-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="StandardDefectForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="code">Code:</label>
                                    <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                    <div class="field-error">{{code_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="name">Name:</label>
                                    <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                    <div class="field-error">{{name_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="location_id">Location:</label>
                                    <v-select v-model="location_id" style="height:40px" name="location_id" placeholder="Select Locations."
                                                label="text"
                                                :options="locationnameArr" id="location_id">
                                    </v-select>
                                    <div class="field-error">{{location_name_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="department_id">Department:</label>
                                    <v-select v-model="department_id" style="height:40px" name="department_id" placeholder="Select Department."
                                                label="text"
                                                :options="departmentnameArr" id="department_id">
                                    </v-select>
                                    <div class="field-error">{{department_name_error_msg}}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" id="createStandardDefectBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateStandardDefect" >
                                <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="createStandardDefectBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateStandardDefect"> 
                                <i class="fp-save"> </i>  Save
                                </button>
                                <button type="submit" id="createAndContinueStandardDefectBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateStandardDefect(flag='Save and Continue')" >
                                <i class="fp-save-continue"> </i>  Save and Continue
                                </button>
                                <button type="submit" id="cancelStandardDefectBtn" class="btn btn-tertiary" v-on:click.prevent="BackStandardDefectList" >
                                <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>

<script>
    import Vue from "vue";
    
    import {commonMixins} from '../mixins/commonMixins';
    
    
    

    export default {
        name: "StandardDefectCreate",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Standard Defect | " +process.env.COPYRIGHT_NAME : "Create Standard Defect | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
            permissions: [],
            cantAccessPage: "",
            name: "",
            code: "",
            location_id: null,
            locationnameArr: [],
            department_id: null,
            departmentnameArr: [],
            loading:false,
            name_error_msg: "",
            code_error_msg: "",
            location_name_error_msg: "",
            department_name_error_msg: "",
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_standard_defect' ) {
                            self.cantAccessPage = true;

                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadLocation();
            self.loadDepartment();
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadStandardDefect();
            }
        },
        methods: {

            BackStandardDefectList() {
                var self = this;
                self.$router.push("/standard-defect/list");
            },

            CreateStandardDefect(flag) {
                var self = this;
                var error = false;

                self.code = self.code.trim();
                self.name = self.name.trim();

                self.code_error_msg = "";
                self.name_error_msg = "";
                self.location_name_error_msg = "";
                self.department_name_error_msg = "";

                if (!self.code || self.code == null || self.code == "") {
                    self.code_error_msg = "Code Required.";
                    error = true;
                }

                if (!self.name || self.name == null || self.name == "") {
                    self.name_error_msg = "Name Required.";
                    error = true;
                }
                if (self.location_id == null || !self.location_id.value) {
                    self.location_name_error_msg = "Location Required.";
                    error = true;
                }
                if (self.department_id == null || !self.department_id.value) {
                    self.department_name_error_msg = "Department Required.";
                    error = true;
                }

                if (!error) {
                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[3])
                    {
                        $("#createStandardDefectBtn").val("Updating ...");
                        $("#createStandardDefectBtn").prop("disabled", true);
                        $("#cancelStandardDefectBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueStandardDefectBtn").val("Saving ...");
                            $("#createStandardDefectBtn").prop("disabled", true);
                            $("#createAndContinueStandardDefectBtn").prop("disabled", true);
                            $("#createStandardDefectBtn").prop("disabled",true);

                        }else{

                            $("#createStandardDefectBtn").val("Saving ...");
                            $("#createStandardDefectBtn").prop("disabled", true);
                            $("#createAndContinueStandardDefectBtn").prop("disabled", true);
                            $("#cancelStandardDefectBtn").prop("disabled",true);
                        }

                    }
                    var fields = $('#StandardDefectForm').serializeArray();
                    fields.push({name: "location_id", value: self.location_id.value});
                    fields.push({name: "department_id", value: self.department_id.value});
                    fields.push({name: "id", value: segments[3]});

                    $.ajax({
                        url: process.env.ROOT_API + "/standard-defect/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createStandardDefectBtn").val("Update");
                                $("#createStandardDefectBtn").prop("disabled", false);
                                $("#createStandardDefectBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueStandardDefectBtn").val("Save and Continue");
                                    $("#createStandardDefectBtn").prop("disabled", false);
                                    $("#createAndContinueStandardDefectBtn").prop("disabled", false);
                                    $("#createStandardDefectBtn").prop("disabled",false);

                                }else{

                                    $("#createStandardDefectBtn").val("Save");
                                    $("#createStandardDefectBtn").prop("disabled", false);
                                    $("#createAndContinueStandardDefectBtn").prop("disabled", false);
                                    $("#cancelStandardDefectBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    // $("#VehicleStatusForm").trigger("reset");
                                    self.name = "";
                                    self.code = "";
                                    self.location_id = null;
                                    self.department_id = null;
                                    // self.manufacturercodeArr = "";

                                }else{
                                    self.$router.push("/standard-defect/list");
                                }

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createStandardDefectBtn").val("Update");
                                $("#createStandardDefectBtn").prop("disabled", false);
                                $("#createStandardDefectBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    // $("#VehicleStatusForm").trigger("reset");

                                    $("#createAndContinueStandardDefectBtn").val("Save and Continue");
                                    $("#createStandardDefectBtn").prop("disabled", false);
                                    $("#createAndContinueStandardDefectBtn").prop("disabled", false);
                                    $("#createStandardDefectBtn").prop("disabled",false);

                                }else{

                                    $("#createStandardDefectBtn").val("Save");
                                    $("#createStandardDefectBtn").prop("disabled", false);
                                    $("#createAndContinueStandardDefectBtn").prop("disabled", false);
                                    $("#cancelStandardDefectBtn").prop("disabled",false);

                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'std-defect-create')
                        }
                    });
                }else{
                    self.errorValidationFocus();
                }
            },

            loadStandardDefect() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/standard-defect/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                         console.log(data)
                        self.loading = false;
                        if (data.status == "success") {
                            self.name = data.content.name;
                            self.code = data.content.code;
                            if(data.content.location_id == null) {
                                self.location_id = null;
                            }else{
                                self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name)};
                            }
                            if(data.content.department_id == null) {
                                self.department_id = null;
                            }else{
                                self.department_id = {value: data.content.department_id, text: self.titleCase(data.content.deptName + " (" + data.content.deptCode +")")};

                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'std-defect-by-id')
                    }
                });
            },
            loadLocation() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/locations/all",
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{flag:"json"},
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content.email);
                        if (data.status == "success") {

                            self.locationnameArr = data.content.locations;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'std-defect-load-location')
                    }
                });
            },
            loadDepartment() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/department/all",
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{flag:"json"},
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content.email);
                        if (data.status == "success") {

                            self.departmentnameArr = data.content.departments;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'std-defect-load-dprt')
                    }
                });
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/StandardDefectCreate.vue